// extracted by mini-css-extract-plugin
export default {"arrow":"backArrowButton_arrow__STAw8","arrowLeft":"backArrowButton_arrowLeft__v+1p0"};